export enum Language {
  EN = 'en',
  NL = 'nl',
  TR = 'tr',
  ES = 'es',
  DE = 'de',
  SV = 'sv',
  RO = 'ro',
}